import { render, staticRenderFns } from "./AbelLibros.vue?vue&type=template&id=58037548&scoped=true&"
import script from "./AbelLibros.vue?vue&type=script&lang=js&"
export * from "./AbelLibros.vue?vue&type=script&lang=js&"
import style0 from "./AbelLibros.vue?vue&type=style&index=0&id=58037548&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58037548",
  null
  
)

export default component.exports